module.exports = __webpack_public_path__ + "static/media/adnan-darwiche.6119e83c.jpg";